module.exports = __webpack_public_path__ + "d46126613e96d5a1e9d1b4cba85207ce.png";